<script lang="ts">
  let {
    children,
    element = "button",
    variant = "primary",
    href,
    onclick,
    disabled = false,
  }: {
    children: any;
    element?: "button" | "a";
    variant?: "primary" | "secondary" | "d2c-primary" | "dietitian-card-primary" | string;
    href?: string;
    disabled?: boolean;
    onclick: () => void;
  } = $props();
</script>

<svelte:element this={element} {href} class={variant} {onclick} role="button" tabindex="0" {disabled}>
  {#if children}
    {@render children()}
  {/if}
</svelte:element>

<style lang="scss">
  button,
  a {
    background-color: #ff5c3b;
    font-family: "Plus Jakarta Sans", sans-serif;
    color: white;
    border-radius: 68px;
    margin-bottom: 0;
    padding: 20px 30px;
    line-height: 100%;
    transition: background-color 0.4s;
    font-weight: 600;
    cursor: pointer;
    min-width: 12rem;
    text-align: center;

    &:hover {
      background-color: #d33d1f;
    }

    &:disabled {
      background-color: #c2c2c2;
      cursor: not-allowed;
      color: white;
      border: 1px solid #c2c2c2;
    }
    &:disabled:hover {
      background-color: #c2c2c2;
    }
  }

  .secondary {
    background-color: #fff;
    color: #ff5c3b;
    border: 1px solid #ff5c3b;

    &:hover {
      background-color: #ffc1b686;
    }
  }
  .dietitian-card-primary {
    width: 100%;
    max-width: 420px;
    padding: 16px 32px;
    font-size: 16px;
  }
  .d2c-primary {
    background-color: #71c473;
    border-radius: 8px;
    &:hover {
      background-color: #59ac5b;
    }
  }
  @media (max-width: 600px) {
    button,
    a {
      min-width: 6rem;
    }
  }
</style>
